import React from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';

import { useTranslation } from 'react-i18next';

const PieChart = ({
  data, unitName, title, smallPie, bigPie, hideLegend, backgroundColor,
}) => {
  const { t } = useTranslation(['translation']);
  const variants = {
    normal: {
      legend: {
        orient: 'vertical',
        y: 'center',
        left: '65%',
      },
      series: {
        center: ['35%', '50%'],
        radius: ['55%', '65%'],
      },
    },
    smallPie: {
      legend: {
        orient: 'horizontal',
        y: '30px',
        left: 'center',
      },
      series: {
        center: ['50%', '60%'],
        radius: ['62%', '72%'],
      },
    },
    bigPie: {
      legend: {
        orient: 'horizontal',
        y: '30px',
        left: 'center',
      },
      series: {
        center: ['50%', '50%'],
        radius: ['72%', '80%'],
      },
    },
  };
  // TODO: these modes should be refactored
  const pieVariant = bigPie ? variants.bigPie : smallPie ? variants.smallPie : variants.normal;
  const options = {
    title: {
      show: title !== null,
      text: title,
      textStyle: {
        fontSize: 15,
        color: '#666C6F',
        height: 45,
      },
      left: 'center',
    },
    legend: {
      show: !hideLegend,
      orient: pieVariant.legend.orient,
      y: pieVariant.legend.y,
      left: pieVariant.legend.left,
      align: 'left',
      icon: 'circle',
      textStyle: {
        color: '#666C6F',
      }
    },
    backgroundColor,
    series: {
      type: 'pie',
      center: pieVariant.series.center,
      radius: pieVariant.series.radius,
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: 'center',
          fontSize: 16,
          color: '#666C6F',
          formatter: ({ name, percent, value }) => `{b|${name}} \n {d|${percent}%} \n {c|${t('COMMON.INTL_NUMBER', { value })} ${unitName}}`,
        },
        emphasis: {
          show: true,
          rich: {
            d: {
              fontSize: 36,
              fontWeight: 300,
              padding: [15, 0],
            },
          },
        },
      },
      labelLine: {
        normal: {
          show: false,
        },
      },
      data,
    },
    color: [
      new echarts.graphic.LinearGradient(
        0, 0, 0, 1,
        [{ offset: 0, color: '#0A41BF' }, { offset: 1, color: '#2F6BF4' }],
      ),
      new echarts.graphic.LinearGradient(
        0, 0, 0, 1,
        [{ offset: 0, color: '#BA3312' }, { offset: 0.6, color: '#FF3301' }],
      ),
      new echarts.graphic.LinearGradient(
        0, 0, 0, 1,
        [{ offset: 0, color: '#102131' }, { offset: 1, color: '#38526B' }],
      ),
    ],
  };

  return (
    <ReactEcharts
      option={options}
      notMerge
      theme="dark"
      style={{ width: '99%', height: '100%' }}
    />
  );
};

PieChart.defaultProps = {
  title: null,
  smallPie: false,
  bigPie: false,
  hideLegend: false,
  backgroundColor: 'white',
};

PieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  unitName: PropTypes.string.isRequired,
  title: PropTypes.string,
  smallPie: PropTypes.bool,
  bigPie: PropTypes.bool,
  hideLegend: PropTypes.bool,
  backgroundColor: PropTypes.string,
};

export default PieChart;
